import { render, staticRenderFns } from "./b-ticket-booking-details.vue?vue&type=template&id=3a1c9e3a&scoped=true"
import script from "./b-ticket-booking-details.vue?vue&type=script&lang=ts"
export * from "./b-ticket-booking-details.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-booking-details.vue?vue&type=style&index=0&id=3a1c9e3a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1c9e3a",
  null
  
)

export default component.exports